import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  DateRow,
  DetailPageWrapper,
  DrawerMain,
  EditBtn,
  PhoneRow,
  StatusPopper,
  TitleValue,
  Upload,
} from "components";
import {
  AccordionSimple,
  AllStatusesEnum,
  ChangePassword,
  ResendInvite,
} from "fragments";
import { CHANGE_CHARITY_STATUS } from "./constants";
import {
  ChangePasswordAccorHeader,
  ChangePasswordDrawerContent,
} from "../../charities/fragments/changePasswordAccordion";
import { charityActions } from "store";
import { ProfileInfo, useWindowDimensions } from "utils";

export const CharityInfo = ({ setEditMode }) => {
  const [expanded, setExpanded] = useState(null);
  const { charityById } = useSelector((state) => ({
    charityById: state.charity.charityById,
  }));
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { ifCharity, ifAdmin } = ProfileInfo();

  const handleUpload = (item) => {
    const params = {
      ...charityById,
      mainImage: item?.mainImage,
    };
    params.imagesToAdd = item?.files;
    dispatch(charityActions.editCharity(charityById?.id, params, "noLoad"));
  };

  const handleSetMain = (main) => {
    const params = {
      ...charityById,
    };
    params.mainImage = main;
    dispatch(charityActions.editCharity(charityById?.id, params, "noLoad"));
  };

  const handleDeleteImage = (item) => {
    const params = {
      ...charityById,
    };
    params.imagesToRemove = [item];
    dispatch(charityActions.editCharity(charityById?.id, params, "noLoad"));
  };

  const changeStatus = (status) => {
    const params = {
      status: status,
    };
    if (ifAdmin) {
      dispatch(charityActions.changeCharityStatus(charityById?.id, params));
    }
  };

  const toggleAccordion = (item, reset) => {
    setExpanded(item?.value === expanded ? null : item?.value);
    if (typeof reset === "function") {
      reset({
        password: "",
        newPassword: "",
        confirmation: "",
      });
    }
  };

  const list = [
    {
      accordionSummary: <ChangePasswordAccorHeader />,
      accordionDetails: width > 767 && (
        <div style={{ maxWidth: 448 }}>
          <ChangePassword handleCancel={toggleAccordion} />
        </div>
      ),
      value: "changePassword",
    },
  ];

  return (
    <div className="fundraiser-detail-screen-wrapper">
      <DetailPageWrapper
        head={
          <>
            <p className="detail-page-title">Basic Information</p>
            <div className="fundraiser-detail-actions">
              {ifCharity && <EditBtn handleClick={() => setEditMode(true)} />}
              <div
                className="charity-status-box"
                style={{ pointerEvents: ifAdmin ? "auto" : "none" }}
              >
                <StatusPopper
                  status={charityById?.status}
                  handleSelect={changeStatus}
                  actionTye={CHANGE_CHARITY_STATUS}
                />
              </div>

              {charityById?.inviteStatus === AllStatusesEnum.INACTIVE && (
                <ResendInvite item={charityById} />
              )}
            </div>
          </>
        }
        body={
          <div>
            <div>
              <TitleValue title="Charity Name" value={charityById?.name} />
              <TitleValue
                title="Creation date"
                value={<DateRow date={charityById?.createdAt} />}
              />
              <TitleValue
                title="Phone Number"
                value={<PhoneRow phone={charityById?.phoneNumber} />}
              />
              <TitleValue title="Email" value={charityById?.email} />
            </div>

            {charityById?.description && (
              <div className="fundraiser-detail-description">
                <p>Description</p>
                <span>{charityById?.description}</span>
              </div>
            )}

            <div
              className="charity-status-mobile-box"
              style={{ pointerEvents: ifAdmin ? "auto" : "none" }}
            >
              <StatusPopper
                status={charityById?.status}
                handleSelect={changeStatus}
                actionTye={CHANGE_CHARITY_STATUS}
              />
            </div>
          </div>
        }
      />

      <DetailPageWrapper
        body={
          <div style={{ pointerEvents: ifCharity ? "auto" : "none" }}>
            <p className="detail-page-title">Add Photo</p>
            <Upload
              handleSetMain={handleSetMain}
              handleChange={handleUpload}
              handleDelete={handleDeleteImage}
              createMany={true}
              backImages={charityById}
            />
          </div>
        }
      />
      {ifCharity && (
        <>
          {width > 767 ? (
            <AccordionSimple
              list={list}
              handleChange={toggleAccordion}
              expanded={expanded}
            />
          ) : (
            <DrawerMain
              anchor="bottom"
              OpeningComponent={(props) => (
                <AccordionSimple
                  {...props}
                  list={list}
                  handleChange={props?.openDrawer}
                />
              )}
              ContentDrawer={ChangePasswordDrawerContent}
            />
          )}
        </>
      )}
    </div>
  );
};
